import { BaseModule } from './BaseModule';
import { ModuleBaseOption } from '../interfaces/module';

class OnStateChange extends BaseModule<ModuleBaseOption> {
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
        }
    }
    private listenFromRCX() {
        this.mRCXAdapter!.onRCXStateChange((data: any) => {
            this.onRCXStateChange(data.baseState);
        });
    }

    private debounceTimer: NodeJS.Timeout | null = null;

    public async onRCXStateChange(data: any) {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            this.mServiceNowAdapter!.getStateSyncAdapter()?.updatePresenceState(data);
            this.debounceTimer = null;
        }, 500);
    }
}

export default new OnStateChange();
